import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { setCustomerAgentLogin, getGeoInfo, registrationagentemailcheck, setAgentSignup } from './axios';
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./AgentSignup.css";
import Spinner from 'react-bootstrap/Spinner';

//const regularExpression = RegExp(/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/)
const validEmailRegex = RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);


export default function AgentSignup() {

    const [Newcountry, setCountry] = useState({});
    const [countrycode, setCountryCode] = useState({});
    const [Newcurrency, setCurrency] = useState({});
    const [ipaddress, setIpaddress] = useState({});
    const [sussessRegister, setSussessRegister] = useState(false);
    const [EmailRecheck, setEmailRecheck] = useState(false);
    const [PasswordMatchcheck, setPasswordMatchcheck] = useState(false);
    const [btnloader, setbtnloader] = useState(0);
    const [MobileCode, setMobileCode] = useState("");
    const {
        register,
        handleSubmit, watch,
        formState: { errors },
      } = useForm({
        mode: "onChange",
      });
    // static propTypes = {
    //     cookies: instanceOf(Cookies).isRequired
    // };
   
    useEffect(() => {
        getGeoInfo().then(
                  (data) => {
                      setCountry(data.country_name);
                      setCountryCode(data.country_calling_code);
                      setCurrency(data.country_name);
                      setIpaddress(data.ip);
                   
                  },
                  (error) => {}
                );
           
            //    //window.addEventListener("scroll", this.handleScroll);  
    }, []);
   
      // Start On Change Status Data Show
      const onChange = (e) => {
     };

     let OnChangeMobileCode = (event) => {
      console.log(event);
      setMobileCode(event.target.value);
    };
     const password = useRef({});
        password.current = watch("password", "");
     // End On Change Status Data Show
     // On Submit User List
      const onSubmit = (data) => {
        let subData = true;
        setbtnloader(1);

         //Check Validation Email
         //let emailDetails = 'vijay.kapoor@teraidatalabs.com';
       
         registrationagentemailcheck(data.email).then(
      (data) => {
        setbtnloader(0);
        //console.log(data);
        if (data == "exist") {
          setEmailRecheck(true);
          return (subData = false);
        } else {
          setEmailRecheck(false);
        }
      },
      (error) => {}
    );
    setTimeout(() => {
        if (subData) {
            setSussessRegister(false);
          var MobileCodeData = MobileCode != ''? MobileCode: countrycode;
            let first_name = data.firstName;
            let last_name = data.lastName;
            let email = data.email;
            let profile_image = "";
           let birthday = "";
           let gender = "";
           let login_source = 0;
           let mobile_number = data.number;
           let country = Newcountry;
           let country_code = MobileCodeData;
           let currency = Newcurrency;
           let ip_address = ipaddress;
           let password = data.password;
           let verified = 0;
       
           let Verified = '';
           if (verified == 1) {
               Verified = true;
           }

           const dataSearch = {
            first_name: first_name,
            last_name: last_name,
            email: email,
            country_code: MobileCodeData,
            verified: Verified,
            uid: ""
        }
    
        let JsonData = JSON.stringify(dataSearch);
    
        localStorage.setItem('userDetails', JsonData);
        setAgentSignup(first_name, last_name, email, mobile_number, country, country_code, currency, ip_address, password).then(
            (data) => {
               //console.log(data);
               if(data !='exist'){
                setSussessRegister(true);
                var base_url = window.location.origin;
                window.location.href = base_url+"/agentsignupcompleted";
                setbtnloader(0);
               }else{
                setbtnloader(0);
                let text = "This email id is already exist.";
                if (window.confirm(text) == true) {
                }

               }
            },
            (error) => {
    
            }
        );
           
        }

      }, 3000);
      }
    



    return (
            <div id="login">
<aside id="agentsignup">
            <figure> <a href="/">
              <img src="images/logo/seyLogo.png" alt="Holiday Seychelles" className="logo_sticky" />
              </a>
                <p style={{fontSize: '20px', fontWeight: 600}}>Configure your Agent Account</p>
            </figure> <br/>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
           
                <div className="container">
                    <div className="row">
                    {/* {sussessRegister && (
                    <div class="alert alert-success" role="alert">
                    Congratulations, your account has been successfully created. You will be able to login once administrator has verify.
                    </div>
                     )} */}
                    
                        <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label>Email</label>
                                
                                <input   type="email"
                                  className={`form-control ${
                                    errors.email && "Err"
                                  }`}
                                  {...register("email", {
                                    required: true,
                                    minLength: 2,
                                    pattern:
                                      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
                                  })}
                                  id="email"
                                  name="email"
                                  placeholder="Enter Email"
                                />
                                <i className="icon_mail_alt"></i>
                                {errors.email &&
                                  errors.email.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Email
                                    </span>
                                  )}
                                {errors.email &&
                                  errors.email.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Email must be at least 2 characters long!
                                    </span>
                                  )}
                                {errors.email &&
                                  errors.email.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter a valid email address
                                    </span>
                                  )}

                                {EmailRecheck && (
                                  <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                    This email id already exist
                                  </span>
                                )}
                                    
                            </div>
                        </div>
                       
                        <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label>Contact Number</label>

                                <div className="paymakeFlex textLtr" style={{display:'flex'}}>
                                    <div className="guestDtls__contact">
                                        <label for="mCode" className="frmSelectCont__contact">
                                            <select id="mCode" className="frmSelect frmSelectContact form-control"   value={MobileCode}
                                  onChange={OnChangeMobileCode}>
                                          
                                    {DialCode.map((item, key) => (
                                        <option value={item.dial_code}>{item.name}&nbsp;({item.dial_code})</option>
                                    ))}
                                            </select>
                                        </label>
                                        <span className="selectedCode" id="dialCode" style={{padding: '10px'}}>
                                {MobileCode == "" ? +91: MobileCode}
                              </span>
                                        <input type="hidden" id="countryCode" name="countryCode" value={MobileCode == "" ? +91: MobileCode}/>
                                    </div>
                                    <div className="flexOne">
                                        <div className="textFieldCol ">
                                        <input
                                  type="number"
                                  className={`frmTextInput noLeftBorder form-control ${
                                    errors.number && "Err"
                                  }`}
                                  {...register("number", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 15,
                                    pattern: /^[0-9]+$/i,
                                  })}
                                  id="number"
                                  name="number"
                                  placeholder="Enter Contact Number"
                                />
                                <i class="fa fa-phone" aria-hidden="true" style={{paddingLeft: '65px'}}></i>
                                {errors.number &&
                                  errors.number.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Contact Number
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Contact Number must be at least 6
                                      characters long!
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Contact Number should be less then 15
                                      characters !
                                    </span>
                                  )}
                                {errors.number &&
                                  errors.number.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only number
                                    </span>
                                  )}

    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label>First Name</label>
                               
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.firstName && "Err"
                                  }`}
                                  {...register("firstName", {
                                    required: true,
                                    minLength: 2,
                                    maxLength: 50,
                                    pattern: /^[A-Za-z ]+$/i,
                                  })}
                                  id="firstName"
                                  name="firstName"
                                  placeholder="Enter First Name"
                                />
                                 <i className="pe-7s-add-user"></i>
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your First Name
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      First Name must be at least 2 characters
                                      long!
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      First Name should be less then  50
                                      characters !
                                    </span>
                                  )}
                                {errors.firstName &&
                                  errors.firstName.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only alphabets
                                    </span>
                                  )}
                                
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label>Last Name</label>
                                <input
                                  type="text"
                                  className={`form-control ${
                                    errors.lastName && "Err"
                                  }`}
                                  {...register("lastName", {
                                    required: true,
                                    minLength: 2,
                                    maxLength: 50,
                                    pattern: /^[A-Za-z ]+$/i,
                                  })}
                                  id="lastName"
                                  name="lastName"
                                  placeholder="Enter Last Name"
                                />
                                 <i className="pe-7s-add-user"></i>
                                {errors.lastName &&
                                  errors.lastName.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Last Name
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type ===
                                    "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Last Name must be at least 2 characters long!
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type ===
                                    "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Last Name should be less then 50 characters
                                      !
                                    </span>
                                  )}
                                {errors.lastName &&
                                  errors.lastName.type === "pattern" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter only alphabets
                                    </span>
                                  )}

                                               
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label> Password</label>
                                <input
                                  type="password"
                                  className={`form-control ${
                                    errors.password && "Err"
                                  }`}
                                  {...register("password", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 20,
                                  })}
                                  id="password"
                                  name="password"
                                  placeholder="Enter Password"
                                />
                                  <i className="icon_lock_alt"></i>  
                                {errors.password &&
                                  errors.password.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your Password
                                    </span>
                                  )}
                                {errors.password &&
                                  errors.password.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Password must be at least 6 characters
                                      long!
                                    </span>
                                  )}
                                {errors.password &&
                                  errors.password.type === "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Password should be less then 20 characters !
                                    </span>
                                  )}
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="form-group" style={{marginBottom: '1rem'}}>
                                <label> Confirm Password</label>
                                     <input
                                  type="password"
                                  className={`form-control ${
                                    errors.confirmpassword && "Err"
                                  }`}
                                  {...register("confirmpassword", {
                                    required: true,
                                    minLength: 6,
                                    maxLength: 20,
                                    validate: value =>
                                    value === password.current || "The password do not match",
                                  })}
                                  id="confirmpassword"
                                  name="confirmpassword"
                                  placeholder="Enter  Confirm Password"
                                />
                                   <i className="icon_lock_alt"></i>  
                                {errors.confirmpassword && <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>{errors.confirmpassword.message} </span>}
                                
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "required" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Please enter your  Confirm Password
                                    </span>
                                  )}
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "minLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Confirm Password must be at least 6 characters
                                      long!
                                    </span>
                                  )}
                                {errors.confirmpassword &&
                                  errors.confirmpassword.type === "maxLength" && (
                                    <span className="error" style={{color: '#eb4134', textTransform: 'none'}}>
                                      Confirm Password should be less then 20 characters !
                                    </span>
                                  )}


                            </div>
                        </div>
                        <div id="pass-info" className="clearfix"></div>
                    </div>
                </div>

                <button type="submit" className="btn_1 rounded full-width add_top_30">Sign Up  &nbsp;{btnloader === 1 ? (<Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          visually-hidden="true"
        />) : ""}</button>
                <p style={{textAlign: 'center', marginTop: '5px'}}>By signing in, you agree to our <a href="/terms" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy Policy.</a></p>
                <div className="text-center add_top_10" style={{ marginTop:'0px'}}>Already have an acccount? <strong>
                <Link to='/agentlogin'>Login </Link></strong></div>
                </form>
               
        </aside>
  </div>
        );
   
}